'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../config'),
    returnProfiles = _require.returnProfiles;

var fv = function fv(r, n, pv) {
  return Math.pow(1 + r, n) * pv;
};

var cf = function cf(pv, r, t0, tn, multiplier) {
  var cashflows = [];
  for (var i = t0; i < tn; i += 1) {
    cashflows.push(fv(r, i, pv) * multiplier);
  }
  return cashflows;
};

var npv = function npv(r, cf) {
  var sum = 0;
  for (var i = 0; i < cf.length; i += 1) {
    sum += cf[i] / Math.pow(1 + r, i);
  }
  return sum;
};

var calcReturn = function calcReturn(returnProfile, customEquity, assetClassReturns) {
  if (customEquity !== null && customEquity !== '') {
    return (customEquity * assetClassReturns.equity + (100 - customEquity) * assetClassReturns.debt) / 10000;
  }
  var _returnProfiles$retur = returnProfiles[returnProfile],
      equity = _returnProfiles$retur.equity,
      debt = _returnProfiles$retur.debt;

  return (equity * assetClassReturns.equity + debt * assetClassReturns.debt) / 10000;
};

var returnFactor = function returnFactor(r, i, t) {
  var sum = 0;
  for (var n = 0; n < t; n += 1) {
    sum += Math.pow(1 + r, t - n - 1) * Math.pow(1 + i, n);
  }
  return sum;
};

var calcPath = function calcPath(returns, init, inflows, outflows, k) {
  var balance = [init];
  for (var i = 1; i < returns.length; i += 1) {
    balance.push((balance[i - 1] - outflows[i]) * returns[i] + inflows[i]);
  }
  return balance;
};

var goalPath = function goalPath(start, values, yLabel) {
  var path = [];
  for (var i = 0; i < values.length; i += 1) {
    path.push(_defineProperty({ Age: start + i }, yLabel, Math.round(values[i])));
  }
  return path;
};

module.exports = { fv: fv, cf: cf, npv: npv, calcReturn: calcReturn, returnFactor: returnFactor, calcPath: calcPath, goalPath: goalPath };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/lib/helpers.js
// module id = 69
// module chunks = 0